import { ObjectStackItem } from './ObjectStackItem';
import { getNextID } from './referenceCounter';
export class EnumeratorStackItem extends ObjectStackItem {
    constructor() {
        super(...arguments);
        this.referenceID = getNextID();
    }
    toStructuralKey() {
        return `${this.referenceID}`;
    }
    equals(other) {
        return this === other;
    }
    asEnumerator() {
        return this.value;
    }
}

//# sourceMappingURL=EnumeratorStackItem.js.map
